import {openActiveSubstanceDrawer} from '@/modules/drug-catalog/substances/components/active-substance-drawer/util'
import {ActiveSubstancesColumnsDef} from '@/modules/drug-catalog/substances/components/table-columns'
import {InfiniteDataTableV2, type InfiniteDataTableV2Props} from '@cypro/ui/components/ui/infinite-data-table'
import {DrugCatalogItem} from '@cypro/engine/schema'
import {useTranslate} from '@tolgee/react'
import {useMemo, useCallback} from 'react'
import {LuPill} from 'react-icons/lu'
import {useRouter} from '@tanstack/react-router'

// oxlint-disable-next-line typescript/no-empty-object-type
interface Props<TStartRow> extends Omit<InfiniteDataTableV2Props<DrugCatalogItem, TStartRow>, 'emptyState' | 'columns'> {}

export function ActiveSubstancesTable<TStartRow>({table: tableConfig, virtualizer: virtualizerConfig, ...rest}: Props<TStartRow>) {
  const {t} = useTranslate('common')
  const router = useRouter()

  const getRowUrl = useCallback(
    (row: DrugCatalogItem | undefined) => {
      if (!row) return
      return router.buildLocation({to: '/configuration/drug-catalog/active-substances/new', search: {substanceId: row.id}}).href
    },
    [router]
  )

  const columns = useMemo(
    () => [
      ActiveSubstancesColumnsDef.viewPage({maxSize: 7}),
      ActiveSubstancesColumnsDef.code({maxSize: 8}),
      ActiveSubstancesColumnsDef.name({maxSize: 24}),
      ActiveSubstancesColumnsDef.categories({maxSize: 27}),
      ActiveSubstancesColumnsDef.doseCalculationMethod({maxSize: 16}),
      ActiveSubstancesColumnsDef.doseUnit({maxSize: 13}),
      ActiveSubstancesColumnsDef.status({maxSize: 12}),
    ],
    []
  )

  return (
    <InfiniteDataTableV2<DrugCatalogItem, TStartRow>
      {...rest}
      table={{
        ...tableConfig,
        columns,
        meta: {...tableConfig.meta, getRowUrl},
      }}
      virtualizer={virtualizerConfig}
      emptyState={{
        title: t('no_substances'),
        description: t('create_new_substance_to_get_started'),
        icon: LuPill,
      }}
      onRowClick={openActiveSubstanceDrawer}
    />
  )
}
